import { render, staticRenderFns } from "./fingerfood.vue?vue&type=template&id=872987a6&scoped=true&"
import script from "./fingerfood.vue?vue&type=script&lang=js&"
export * from "./fingerfood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872987a6",
  null
  
)

export default component.exports